"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
function Address({ address }) {
    var _a;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", null, address.addressLine),
        react_1.default.createElement("div", null, address.addressLine2),
        react_1.default.createElement("div", null, address.state),
        react_1.default.createElement("div", null, address.city),
        react_1.default.createElement("div", null, address.zip),
        react_1.default.createElement("div", null, (_a = address.country) === null || _a === void 0 ? void 0 : _a.name)));
}
exports.default = Address;
